import React, { useState, useEffect } from "react";
import CarIcon from "@mui/icons-material/DirectionsCar";
import BikeIcon from "@mui/icons-material/DirectionsBike";
import WalkingIcon from "@mui/icons-material/DirectionsWalk";
import "../styles/flashes.css";

const FlashDurations = ({ latitude, longitude, userLocation, cache, setCache }) => {
  const [durationCar, setDurationCar] = useState(null);
  const [durationBike, setDurationBike] = useState(null);
  const [durationWalk, setDurationWalk] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchFlashDurations = async (latitude, longitude, userLocation) => {
    if (!userLocation) return { durationCar: null, durationBike: null, durationWalk: null };

    const apiKey = "5b3ce3597851110001cf6248e46613e5bcbc4795ae8aa95a345e808d";
    const modes = ["driving-car", "cycling-regular", "foot-walking"];

    const fetchDuration = async (mode) => {
      const url = `https://api.openrouteservice.org/v2/directions/${mode}?api_key=${apiKey}&start=${userLocation.longitude},${userLocation.latitude}&end=${longitude},${latitude}`;
  
      try {
        const response = await fetch(url);
        const data = await response.json();
        const route = data.features[0].properties.summary;
  
        return route.duration / 60;
      } catch (err) {
        console.error(`Error fetching duration for mode ${mode}:`, err);
        return null;
      }
    };

    try {
      const [durationCar, durationBike, durationWalk] = await Promise.all(
        modes.map((mode) => fetchDuration(mode))
      );
  
      return { durationCar, durationBike, durationWalk };
    } catch (err) {
      console.error("Error fetching flash durations:", err);
      return { durationCar: null, durationBike: null, durationWalk: null };
    }
  };

  useEffect(() => {
    console.log("FlashDurations mounted or updated:", { latitude, longitude });
    const fetchDetails = async () => {
      const cacheKey = `${latitude},${longitude}`;
      if (cache[cacheKey]) {
        setDurationCar(cache[cacheKey].durationCar);
        setDurationBike(cache[cacheKey].durationBike);
        setDurationWalk(cache[cacheKey].durationWalk);
        setLoading(false);
      }
      else {
        setLoading(true);
        const result = await fetchFlashDurations(latitude, longitude, userLocation);
        setDurationCar(result.durationCar);
        setDurationBike(result.durationBike);
        setDurationWalk(result.durationWalk);
        setCache((prevCache) => ({
          ...prevCache,
          [cacheKey]: result,
        }));
        setLoading(false);
      }
    };

    fetchDetails();
  }, [latitude, longitude, userLocation, cache, setCache]);

  if (loading) {
    return <p></p>;
  }

  return (
    <div className="flash-duration-container">
      {!Number.isNaN(durationCar) && durationCar !== null && durationCar !== undefined && (
        <div className="flash-duration">
          <CarIcon style={{ fontSize: 16, color: "#2c3e50" }} />
          <span className="flash-duration-text">{durationCar?.toFixed(0)} mins •</span>
        </div>
      )}

      {!Number.isNaN(durationBike) && durationBike !== null && durationBike !== undefined && (
        <div className="flash-duration">
          <BikeIcon style={{ fontSize: 16, color: "#2c3e50" }} />
          <span className="flash-duration-text">{durationBike?.toFixed(0)} mins •</span>
        </div>
      )}

      {!Number.isNaN(durationWalk) && durationWalk !== null && durationWalk !== undefined && (
        <div className="flash-duration">
          <WalkingIcon style={{ fontSize: 16, color: "#2c3e50" }} />
          <span className="flash-duration-text">{durationWalk?.toFixed(0)} mins</span>
        </div>
      )}
    </div>
  );
};

export default FlashDurations;